import styled from 'styled-components'
import { colors, measurments } from '../utils/config'

const StyledCustomerTextarea = styled.div`
  label,
  span,
  textarea {
    display: block;
  }
  label {
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
    color: inherit;
    font-weight: 500;
  }
  span {
    font-family: 'Inter', sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: inherit;
    opacity: 0.7;
    margin-bottom: 0.4rem;
  }
  textarea {
    resize: vertical;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid ${colors.gray500};
    border-radius: ${measurments.borderRadius}px;
    font-size: 0.875rem;
    color: ${colors.gray700};
    padding: 0.6rem;
  }
  margin-bottom: 1.6rem;
`

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  id: string
  label: string
  desc?: string
  h?: number
}

const CustomerTextarea = (props: Props) => {
  const { label, desc, ...fieldProps } = props
  return (
    <StyledCustomerTextarea>
      {props.label && <label htmlFor={props.id}>{label}</label>}
      {desc && <span>{desc}</span>}
      <textarea {...fieldProps} />
    </StyledCustomerTextarea>
  )
}

export default CustomerTextarea
